module.exports = __webpack_public_path__ + "static/media/vrar.2cc4be13.png";